import { permissionObj } from '../../../../../Helpers/permission';
import ButtonAction from './../../../../../components/buttons/ButtonAction';
import HeadTittle from './../../../../../components/HeadTittle';
import routes from '../../../../../Routes/routes';
import Details from './Details';
import Ingredients from './Ingredients';
import Allergens from './Allergens';
import ManageDishApp from '../Functionality/ManageDishApp';
import DividerWithText from '../../../../../components/DividerWithText';
import { ACTION_MODEL } from '../../../../../Helpers/ActionModel';
import CustomPhotoPicker from '../../../../../components/PhotoPicker/CustomPhotoPicker';
import { EditIcon } from '../../../../../components/buttons/IconButtons';
import { FILE_TYPE } from '../../../../../Helpers/fileType';
import { SUGGESTION_MODE_OPTION } from '../../../../../components/PhotoPicker/SubComponent/Models/Models';
/**
 * @Author: Susana Garcia Rodriguez
 * @JobTitle : Frontend
 * @Email : sgarcia@ibl.mx
 *
 */
const ManageDish = () => {
    const {
        t,
        DEV,
        permission,
        item,
        handleChange,
        disabled,
        emptyFields,
        errorCode,
        errorName,
        selectedIngredients,
        setSelectedIngredients,
        selectedAllergens,
        setSelectedAllergens,
        selectedDietTypes,
        setSelectedDietTypes,
        handleUpdate,
        handleDeleteImage,
        photoPicker,
        setPhotoPicker,
        handleIngredientDelete,
        handleDietTypeDelete,
        handleAllergenDelete,
        emptyAllergens,
        emptyIngredients,
        permissionUpdate
    } = ManageDishApp();
    return (
        <>
            <HeadTittle name={permissionUpdate ? 'update' : 'details'} link={routes.foodie.list}>
                {(DEV || permission?.includes(permissionObj?.WEB_FOODIE_ITEM_UPDATE)) && (
                    <ButtonAction
                        id='btn_md_update_data'
                        className='btn-icon-edit'
                        Icon={EditIcon}
                        name='update'
                        onClick={() => {
                            handleUpdate();
                        }}
                    />
                )}
            </HeadTittle>
            <div>
                <div className='col-12 my-3'>
                    <DividerWithText title={t('photography')} />
                </div>
                <div className='col-12'>
                    <CustomPhotoPicker
                        id='fp_md_photo_file'
                        photoPicker={photoPicker}
                        setPhotoPicker={setPhotoPicker}
                        actionModel={ACTION_MODEL.UPDATE}
                        accept={{ ...FILE_TYPE.IMAGE }}
                        showBtnDelete={true}
                        required={true}
                        disabled={disabled}
                        showBtnCamera={true}
                        validateFace={false}
                        classWith={'w-400px'}
                        showPreview={true}
                        typeSuggestions={SUGGESTION_MODE_OPTION.INGREDIENTS}
                        titleModalEdit={'update_meal_photograph'}
                        handleDelete={ photoPicker?.previewImage != null ? () => handleDeleteImage() : undefined}
                    />
                </div>
                <Details
                    t={t}
                    item={item}
                    disabled={disabled}
                    emptyFields={emptyFields}
                    handleChange={handleChange}
                    errorCode={errorCode}
                    errorName={errorName}
                />
                <div className='mb-4'>
                    <DividerWithText title={t('ingredients')} />
                </div>
                <Ingredients
                    ingredients={[]}
                    item={item}
                    disabled={disabled}
                    handleChange={handleChange}
                    selectedIngredients={selectedIngredients}
                    setSelectedIngredients={setSelectedIngredients}
                    handleIngredientDelete={handleIngredientDelete}
                    emptyFields={emptyIngredients}
                    t={t}
                    permissionUpdate={permissionUpdate}
                />
                <div className='mt-4'>
                    <Allergens
                        t={t}
                        disabled={disabled}
                        handleChange={handleChange}
                        allergens={item.allergenIds}
                        dietType={item.dietTypeIds}
                        selectedAllergens={selectedAllergens}
                        setSelectedAllergens={setSelectedAllergens}
                        selectedDietTypes={selectedDietTypes}
                        setSelectedDietTypes={setSelectedDietTypes}
                        handleDietTypeDelete={handleDietTypeDelete}
                        handleAllergenDelete={handleAllergenDelete}
                        emptyFields={emptyAllergens}
                        permissionUpdate={permissionUpdate}
                    />
                </div>
            </div>
        </>
    );
};

export default ManageDish;
